// extracted by mini-css-extract-plugin
export default {"containerInfo":"Info_containerInfo__42ZFP","headerInfo":"Info_headerInfo__vcHu5","bodyInfo":"Info_bodyInfo__h2Qsp"};